import Base from './Base';

class Visitor extends Base {
    get(opts = null) {
        return this.getJSONWithSession<{ visitorId: string; audiences: string[]; isNew: boolean }>(
            '/visitor',
            null,
            opts,
        );
    }

    addAudiences(audiences, opts = null) {
        return this.isBot
            ? Promise.resolve([])
            : this.postJSONWithSession<string[]>(
                  '/visitor/audiences',
                  {
                      audiences,
                  },
                  opts,
              );
    }
}

export default Visitor;
